export const ENTERPRISE_CALLBACK_VERBS = [
  { label: 'GET', value: 0 },
  { label: 'POST', value: 1 },
  { label: 'PATCH', value: 2 },
  { label: 'PUT', value: 3 },
  { label: 'DELETE', value: 4 }
];

export const verbToCallbackUrlVerb = verb => {
  const found = ENTERPRISE_CALLBACK_VERBS.find(v => v.label === verb);
  return found ? found.value : 1;
};

export const callbackUrlVerbToVerb = n => {
  const found = ENTERPRISE_CALLBACK_VERBS.find(v => v.value === Number(n));
  return found ? found.label : 'POST';
};

export const ENTERPRISE_CALLBACK_EVENT_OPTIONS = [
  { api: 'request_generate', label: 'Request Generate' },
  { api: 'request_complete', label: 'Request Complete' },
  { api: 'output_edit', label: 'Output Edit' },
  { api: 'request_edit', label: 'Request Edit' },
  { api: 'request_export', label: 'Request Export' },
  { api: 'request_regenerate', label: 'Request Regenerate' },
  { api: 'request_regenerate_completed', label: 'Request Regenerate Completed' },
  { api: 'takeoff_complete', label: 'Takeoff Complete' },
  { api: 'sync_complete', label: 'Sync Complete' },
  { api: 'takeoff_queued', label: 'Takeoff Queued' },
  { api: 'takeoff_in_progress', label: 'Takeoff In Progress' },
  { api: 'takeoff_cancelled', label: 'Takeoff Cancelled' }
];
